import React from "react";
import { TextField } from "@mui/material";
import FieldLabel from "./FieldLabel";

// Free-form hh:mm entry rather than a 30-minute-interval dropdown. The browser
// chrome handles the am/pm toggle natively (and 24-hour entry in locales that
// prefer it). The underlying value is still HH:mm so the form state and the
// API contract are unchanged.
const DeliveryTimeField = ({ value, onChange }) => (
	<div>
		<FieldLabel required>Delivery Time</FieldLabel>
		<TextField
			type="time"
			variant="outlined"
			fullWidth
			value={value || ""}
			onChange={(e) => onChange(e.target.value)}
			inputProps={{ step: 60 }}
		/>
	</div>
);

export default DeliveryTimeField;
